import React from 'react'
import { closeModal, modalOptions } from '../../../redux/slices/ModalSlice'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalFooter from 'react-bootstrap/ModalFooter'
import './ModalComponent.css'
// import 'bootstrap/dist/css/bootstrap.min.css'

const ModalComponent = (props: any) => {
const modal: any = useSelector(modalOptions)
const dispatch = useDispatch()

const onClose = () => {
    dispatch(closeModal())
}
return (
    <Modal contentClassName="modal-content" className="modal" show={modal[props.modalName]} centered size='lg'>
    <ModalHeader>
        <button className="close" onClick={onClose}>
        X
        </button>
    </ModalHeader>
    <ModalBody className="modal-body">{props.children}</ModalBody>
    <ModalFooter>
        <button className="modal-close-btn" onClick={onClose}>
        Close
        </button>
    </ModalFooter>
    </Modal>
)
}

export default ModalComponent
